import Vue from 'vue'
import newsConstants from '@/modules/news/config/newsConstants'
Vue.prototype.$newsConstants = newsConstants
Vue.prototype.$allNewsTyps = [
  newsConstants.TYPE_HAKKA,
  newsConstants.TYPE_POLITICAL,
  newsConstants.TYPE_MEDICAL,
  newsConstants.TYPE_LOCAL,
  newsConstants.TYPE_INTERNATIONAL,
]

Vue.prototype.$allNewsSubTyps = [
  newsConstants.NEWS_SUBTYPE_ENTERTAINMENT,
  newsConstants.NEWS_SUBTYPE_INTERNAL,
  newsConstants.NEWS_SUBTYPE_LIFE,
  newsConstants.NEWS_SUBTYPE_TRAVEL,
]
export default {
  onAppLaunch(vm) {
    Vue.prototype.$newsSelector = ({ applyCallback, closeCallback = null, usedList = [], max }) => {
      vm.$targetSelector.active(vm, {
        title: vm.i18n('module.news'),
        bodySlot: () => import('modules/news/selector/newsList.vue'),
        max: max === undefined ? 1 : max,
        applyCallback,
        closeCallback,
        usedList,
      })
    }
  }
}